import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidButton } from '../../../components/rid-button/rid-button';
import { RidDemoPage } from '../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-reading-matrix-page',
  imports: [RidDemoPage, RidButton],
  templateUrl: './reading-matrix-page.html',
})
export class ReadingMatrixPage {
  protected readonly $router = inject(Router);
}
